import {
  WAIT_LOGIN,
  DO_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGIN_CLEAR_MSG,
  TO_OTHER_PAGE,
  RE_LOGIN_SUCCESS,
  WAIT_FORGOT_PWD,
  DO_FORGET_PWD,
  DO_FORGET_PWD_SUCCESS,
  DO_FORGET_PWD_FAIL,
  DO_RESET_PWD,
  DO_RESET_PWD_SUCCESS,
  DO_RESET_PWD_FAIL,
  SHOW_ACCOUNT_CONFIG,
  SHOW_RESET_PWD,
  CLOSE_ACCOUNT_CONFIG,
  CLOSE_RESET_PWD,
  DO_CHANGE_NAME,
  DO_CHANGE_NAME_SUCCESS,
  DO_CREATE_ACCOUNT,
  DO_CREATE_ACCOUNT_SUCCESS,
  DO_CREATE_ACCOUNT_FAIL,
  DO_CHANGE_TIMEZONEID_SUCCESS,
  DO_CHANGE_NAME_FAIL,
  GET_COMPLETE_TUTORIAL_DATA,
  GET_COMPLETE_TUTORIAL_DATA_SUCCESS,
  VERIFY_EMAIL,
  VERIFY_EMAIL_LOADING,
  VERIFY_EMAIL_SEND_CODE_FAIL,
  VERIFY_EMAIL_SEND_CODE_SUCCESS,
} from '../actions/login/index';

const forwardLogin = (state, action) => {
  let accountInfo = state.accountInfo;
  switch (action.type) {
    case WAIT_LOGIN:
      return {
        ...state,
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        status: WAIT_LOGIN,
        loading: false,
        showForgotPwd: false,
        resetPwdLoading: false,
      }
    case DO_LOGIN:
    case VERIFY_EMAIL_LOADING:
      return {
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        errMsg: null,
        status: DO_LOGIN,
        loading: true,
        timeZoneID: null
      }
    case LOGIN_SUCCESS:
      return {
        authToken: action.params.authToken,
        accountInfo: action.params.accountInfo,
        accountRole: action.params.accountRole,
        roleTableAuth: action.params.roleTableAuth,
        errMsg: null,
        status: LOGIN_SUCCESS,
        loading: false,
        timeZoneID: action.params.timeZoneID
      }
    case RE_LOGIN_SUCCESS:
      return {
        authToken: action.params.authToken,
        accountInfo: action.params.accountInfo,
        accountRole: action.params.accountRole,
        roleTableAuth: action.params.roleTableAuth,
        timeZoneID: action.params.timeZoneID,
        errMsg: null,
        status: RE_LOGIN_SUCCESS,
        loading: false,
      }
    case VERIFY_EMAIL:
      return {
        ...state,
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        errMsg: action.params.errMsg,
        notificationContent: action.params.notificationContent,
        username: action.params.username,
        password: action.params.password,
        status: VERIFY_EMAIL,
        loading: false
      }
    case VERIFY_EMAIL_SEND_CODE_FAIL:
      return {
        ...state,
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        errMsg: action?.params?.errMsg,
        status: VERIFY_EMAIL_SEND_CODE_FAIL,
        loading: false
      }
    case VERIFY_EMAIL_SEND_CODE_SUCCESS:
      return {
        ...state,
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        errMsg: null,
        status: VERIFY_EMAIL_SEND_CODE_SUCCESS,
        loading: false
      }
    case LOGIN_FAIL:
      return {
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        errMsg: action.params.errMsg,
        status: LOGIN_FAIL,
        loading: false
      }
    case WAIT_FORGOT_PWD:
      return {
        authToken: null,
        accountInfo: null,
        accountRole: null,
        roleTableAuth: null,
        errMsg: null,
        status: WAIT_FORGOT_PWD,
        // sendMail: null,
        loading: false,
        showForgotPwd: true,
        forgotPwdLoading: false
      }
    case SHOW_ACCOUNT_CONFIG:
      return {
        ...state,
        status: SHOW_ACCOUNT_CONFIG,
        showAccountConfig: true,
        accountConfigLoading: false
      }
    case SHOW_RESET_PWD:
      return {
        ...state,
        status: SHOW_RESET_PWD,
        showResetPwd: true,
        resetPwdLoading: false
      }
    case CLOSE_RESET_PWD:
      return {
        ...state,
        status: CLOSE_RESET_PWD,
        showResetPwd: false,
        resetPwdLoading: true
      }
    case CLOSE_ACCOUNT_CONFIG:
      return {
        ...state,
        status: CLOSE_ACCOUNT_CONFIG,
        showAccountConfig: false,
        accountConfigLoading: true,
        showResetPwd: false,
        resetPwdLoading: true
      }
    case DO_FORGET_PWD:
      return {
        ...state,
        status: DO_FORGET_PWD,
        forgotPwdLoading: true
      }
    case DO_FORGET_PWD_SUCCESS:
      return {
        ...state,
        status: DO_FORGET_PWD_SUCCESS,
        sendMail: action.params.sendMail,
        forgotPwdLoading: false,
        showForgotPwd: true
      }
    case DO_FORGET_PWD_FAIL:
      return {
        ...state,
        status: DO_FORGET_PWD_FAIL,
        showForgotPwd: true,
        forgotPwdLoading: false,
        errMsg: action.params.errMsg
      }
    case DO_RESET_PWD:
      return {
        ...state,
        status: DO_RESET_PWD,
        resetPwdLoading: true
      }
    case DO_RESET_PWD_SUCCESS:
      return {
        ...state,
        status: DO_RESET_PWD_SUCCESS,
        resetPwdLoading: false
      }
    case DO_RESET_PWD_FAIL:
      return {
        ...state,
        status: DO_RESET_PWD_FAIL,
        resetPwdLoading: false,
        errMsg: action.params.errMsg
      }
    case LOGIN_CLEAR_MSG:
      return {
        ...state,
        errMsg: null
      }
    case DO_CHANGE_NAME:
    return {
      ...state,
      status: DO_CHANGE_NAME,
    }
    case DO_CHANGE_NAME_SUCCESS:
      accountInfo.name = action.params.name;
      return {
        ...state,
        status: DO_CHANGE_NAME_SUCCESS,
        authToken: action.params.authToken,
        accountInfo: action.params.accountInfo,
        accountRole: action.params.accountRole,
        timeZoneID: action.params.timeZoneID,
        errMsg: undefined
      }
    case DO_CHANGE_NAME_FAIL:
      return {
        ...state,
        errMsg: action.params.errMsg
      }
    case TO_OTHER_PAGE: // to avoid auto show login
      return {
        ...state,
        status: TO_OTHER_PAGE
      }
      case DO_CREATE_ACCOUNT:
        return {
            ...state,
            status: DO_CREATE_ACCOUNT,
            loading: true
        }
    case DO_CREATE_ACCOUNT_SUCCESS:
        return {
            ...state,
            status: DO_CREATE_ACCOUNT_SUCCESS,
            loading: false
        }
    case DO_CREATE_ACCOUNT_FAIL:
        return {
            ...state,
            status: DO_CREATE_ACCOUNT_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case DO_CHANGE_TIMEZONEID_SUCCESS:
      return{
        ...state,
        timeZoneID: action.params.timeZoneID
      }
    case GET_COMPLETE_TUTORIAL_DATA:
      return {
        ...state,
        status: GET_COMPLETE_TUTORIAL_DATA,
        accountInfo: null
      }
    case GET_COMPLETE_TUTORIAL_DATA_SUCCESS:
      return {
        ...state,
        status: GET_COMPLETE_TUTORIAL_DATA_SUCCESS,
        accountInfo: action.params.accountInfo
      }
    default:
      return state;
    }
}

const loginReducers = (state = {
  authToken: null,
  accountInfo: null,
  accountRole: null,
  roleTableAuth: null,
  errMsg: null,
  status: WAIT_LOGIN,
  loading: false,
  sendMail: null,
  showForgotPwd: false,
  forgotPwdLoading: false,
  showAccountConfig: false,
  accountConfigLoading: false,
  showResetPwd: false,
  resetPwdLoading: false,
  timeZoneID: null,
  completeTutorial: null,
  notificationContent: null,
}, action) => {
  switch (action.type) {
    default:
      return forwardLogin(state, action);
  }
}

export default loginReducers;